import React from 'react';
import { Box } from '@mui/material';
import { FiltersListLayoutProps } from '../types';

const StaticFiltersListLayout = ({ filters, toggleFilter }: FiltersListLayoutProps) => {
  return (
    <>
      {filters
        .filter(item => !item.disabled)
        .map(({ label, element, id, source }) => {
          return (
            <Box
              key={`filter${source}`}
              className="filter-item-wrapper"
              sx={{
                display: 'inline-flex',
                marginRight: '12px',
                marginBottom: '12px',
                '& .input-loader': { transform: 'translateY(5px)' },
              }}
            >
              {React.cloneElement(element, {
                onRemoveCallback: () => toggleFilter(id),
                label,
                source,
                key: source,
              })}
            </Box>
          );
        })}
    </>
  );
};

export default StaticFiltersListLayout;
